import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import MultifactorInfoCodeEn from '../../../../../../common/assets/images/multifactorInfo/multifactor-info-code-en.png';
import MultifactorInfoCodeRo from '../../../../../../common/assets/images/multifactorInfo/multifactor-info-code-ro.png';
import MultifactorInfoEmailEn from '../../../../../../common/assets/images/multifactorInfo/multifactor-info-email-en.png';
import MultifactorInfoEmailRo from '../../../../../../common/assets/images/multifactorInfo/multifactor-info-email-ro.png';
import MultifactorInfoPassEn from '../../../../../../common/assets/images/multifactorInfo/multifactor-info-pass-en.png';
import MultifactorInfoPassRo from '../../../../../../common/assets/images/multifactorInfo/multifactor-info-pass-ro.png';
import { config } from '../../../../config';
import { CustomerInfoContext } from '../../../../contexts/CustomerInfoContext';
import { resources } from '../../../../resources/resources';

export const MultifactorInfo = () => {
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);

  const { code, email, pass } = getImages(customerInfo?.languageCode);

  return (
    <div className="multifactor-info">
      <div
        className="multifactor-text"
        dangerouslySetInnerHTML={{
          __html: translate(resources.multifactor.text),
        }}
      ></div>
      <div className="multifactor-images">
        <div>
          <img
            src={email}
            alt={translate(resources.multifactor.imgAlt.email)}
          />
        </div>
        <div>
          <img
            src={pass}
            alt={translate(resources.multifactor.imgAlt.password)}
          />
        </div>
        <div>
          <img src={code} alt={translate(resources.multifactor.imgAlt.code)} />
        </div>
      </div>
      <div
        className="multifactor-list"
        dangerouslySetInnerHTML={{
          __html: translate(resources.multifactor.list),
        }}
      ></div>
    </div>
  );
};

const getImages = (
  languageCode?: string,
): { code: string; email: string; pass: string } => {
  const language = languageCode ?? config.defaultLanguage;
  if (language === 'en') {
    return {
      email: MultifactorInfoEmailEn,
      pass: MultifactorInfoPassEn,
      code: MultifactorInfoCodeEn,
    };
  }
  if (language === 'ro') {
    return {
      email: MultifactorInfoEmailRo,
      pass: MultifactorInfoPassRo,
      code: MultifactorInfoCodeRo,
    };
  }

  return { pass: '', email: '', code: '' };
};
